import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from '../Button/Button';

const HeaderTopItem = ({ btnClassName, children, ...rest }) => {
  const btnClasses = cn('c-header-top__link', btnClassName);

  return (
    <li className="o-list-inline__item  c-header-top__item">
      <Button className={btnClasses} color="subtle" {...rest}>
        {children}
      </Button>
    </li>
  );
};

export default HeaderTopItem;

HeaderTopItem.propTypes = {
  btnClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

HeaderTopItem.defaultProps = {
  btnClassName: '',
};
